import { useWhiteLabel } from "@hooks/useWhiteLabel";
import { FC } from "react";
import { Typography } from "antd";

const PageFooter: FC = () => {
  const { data: whiteLabel, isLoading } = useWhiteLabel();
  const companyData = whiteLabel?.data?.dati_societari;

  return (
    <div>
      <Typography.Text>
        {!isLoading && companyData ? (
          <>
            <span style={{ whiteSpace: "pre-line" }}>{companyData}</span>
            <br />
          </>
        ) : null}
        <span
          style={{
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
            gap: "5px",
          }}
        >
          Made with love by{" "}
          <a href="https://www.opiquad.com/" rel="noreferrer" target="_blank">
            Opiquad
          </a>
        </span>
      </Typography.Text>
    </div>
  );
};

export default PageFooter;
